var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8894 12.9995C12.3622 12.9995 13.5561 11.8056 13.5561 10.3328C13.5561 8.85996 12.3622 7.66602 10.8894 7.66602C9.4166 7.66602 8.22266 8.85996 8.22266 10.3328C8.22266 11.8056 9.4166 12.9995 10.8894 12.9995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.849 10.1069C20.0648 8.07858 18.7035 6.32451 16.9334 5.06145C15.1632 3.79839 13.0617 3.08172 10.8887 3C8.71562 3.08172 6.61414 3.79839 4.84397 5.06145C3.07379 6.32451 1.71252 8.07858 0.928389 10.1069C0.875433 10.2533 0.875433 10.4137 0.928389 10.5602C1.71252 12.5885 3.07379 14.3426 4.84397 15.6056C6.61414 16.8687 8.71562 17.5854 10.8887 17.6671C13.0617 17.5854 15.1632 16.8687 16.9334 15.6056C18.7035 14.3426 20.0648 12.5885 20.849 10.5602C20.9019 10.4137 20.9019 10.2533 20.849 10.1069ZM10.8887 14.667C10.0316 14.667 9.19377 14.4128 8.48113 13.9367C7.7685 13.4605 7.21307 12.7837 6.88508 11.9919C6.55709 11.2 6.47127 10.3287 6.63848 9.48813C6.80569 8.64752 7.21841 7.87537 7.82446 7.26932C8.4305 6.66328 9.20265 6.25056 10.0433 6.08335C10.8839 5.91614 11.7552 6.00196 12.547 6.32995C13.3388 6.65794 14.0156 7.21337 14.4918 7.926C14.968 8.63864 15.2221 9.47646 15.2221 10.3335C15.2204 11.4823 14.7632 12.5835 13.9509 13.3958C13.1386 14.2081 12.0374 14.6652 10.8887 14.667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconView);
export default __webpack_public_path__ + "static/media/buttonIconView.d10822ab234ddabb5daece9c46d178b2.svg";
export { ForwardRef as ReactComponent };